import Component from '../abstracts/Component';
import TrackingComponent from "./TrackingComponent";
import queryString from 'query-string';
import {buildFullQuery, buildQuery, listingLayoutParams, sortByParams} from "../utils/SearchUrlUtil";
import {getQueryParameterByName} from "../utils/Utils";
import {getFocusElement, hasFocusElement, replacePageInHistory} from "../utils/BrowserHistoryUtils";

export default class FiltersComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-filters]',
      searchHeader: '.search-wrapper .search-header',
      closeDropdown: '.actions .icon-close',
      backdropSearch: '.backdrop-search',
      filterClose: '.js-filter-close',
      pagersContainer: '.js-item-pagination'
    };
  }

  get CLASSES() {
    return {
      active: 'is-active',
      layerVisible: 'layer-visible',
      visible: 'is-visible',
      isFiltered: 'is-filtered',
      menuHidden: 'hidden',
      sortBy: 'sort-by-dropdown',
      backdropClass: 'visible',
      translate: 'translate-filters'
    };
  }

  get QUERY_PARAMS() {
    return {
      base: () => {
        return `?${listingLayoutParams(this.listingLayout)}=true&partial=true&q=%3A${sortByParams(this.sortBy)}`;
      },
    };
  }

  constructor() {
    super();
    this.sortBy = '';
    this.sortMethod = '';
    this.sortName = '';
    this.sortType = '';
    this.listingLayout = '';
    this.page = 0;
    this.main = document.querySelector(this.SELECTORS.main);
    this.trigger = $(this.main.dataset.filtersTrigger);
    this.backdropSearch = $(this.SELECTORS.backdropSearch);
    this.lastScrollTop = 0;
    this.TrackingComponent = new TrackingComponent();
  }

  forceClose() {
    let $main = $(this.main),
        $searchHeader = $(this.SELECTORS.searchHeader);
    if ($searchHeader.length) {
      $searchHeader.removeClass('collapsed');
      $main.removeClass('collapsed-search');
    }
    this.trigger.removeClass(this.CLASSES.active);
    this.main.classList.remove(this.CLASSES.layerVisible);
    document.body.classList.remove(this.CLASSES.layerVisible);
    if (this.$matchMedia('sm', null)) {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
    this.backdropSearch.removeClass(this.CLASSES.backdropClass);
    this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
  }

  scrollPage() {
    // if necessary, scroll the page before opening the filters
    if (this.$matchMedia(null, 'lg')) {
      if (this.main) {
        const filtersPosition = this.main.getBoundingClientRect().top;
        let offset = this.main.style.top.slice(0, -2);
        if (filtersPosition > parseInt(offset)) {
          $('html,body').animate({
              scrollTop: $(this.main).offset().top,
            }, 'slow');
        }
      }
    }

    // fix ie filters sticky
    if (document.documentElement.dataset.browserName == "ie") {
      if (this.main.getBoundingClientRect().top <= 80) {
        this.main.style.position = "fixed";
      } else {
        this.main.style.position = "";
      }
    }
  }

  toggleFiltersLayer(el) {
    // update 11 ottobre per gestire entrambi i filtri
    let $el = $(el),
        $main = $(this.main),
        $searchHeader = $(this.SELECTORS.searchHeader);

    if (document.body.classList.contains(this.CLASSES.layerVisible)) {
      document.body.classList.remove(this.CLASSES.layerVisible);

      if ($el.hasClass(this.CLASSES.active)) {
        this.trigger.removeClass(this.CLASSES.active);
        if ($searchHeader.length) {
          $searchHeader.removeClass('collapsed');
          $main.removeClass('collapsed-search');
        }
      } else {
        this.trigger.removeClass(this.CLASSES.active);
        document.body.classList.add(this.CLASSES.layerVisible);

        setTimeout(() => {
          $el.addClass(this.CLASSES.active);
        }, 300);
      }
    } else {
      // for preventing scroll
      document.body.classList.add(this.CLASSES.layerVisible);

      //if we are over lg scrolls down to collpase menu
      this.scrollPage();

      if ($searchHeader.length) {
        $searchHeader.addClass('collapsed');
        $main.addClass('collapsed-search');
      }

      $el.addClass(this.CLASSES.active);
    }

    if (this.main.classList.contains(this.CLASSES.layerVisible)) {
      // for accessibility purpose

      setTimeout(() => {
        document.querySelector(`${this.main.dataset.filtersLayer} input[type="checkbox"]`).focus();
      }, 200);

      this.$on('keyup.filtersLayer', ({event}) => {
          if (event.which === 27) {
            this.forceClose();
            setTimeout(() => {
              document.querySelector(this.main.dataset.filtersTrigger).focus();
              this.$off('keyup.filtersLayer', this.main.dataset.filtersForm);
            }, 200);
          }
        },
        this.main.dataset.filtersForm
      );
    }
  }

  getPage(query = '', showLoader = true, emitQuery = true, pagequery = '',skipScroll=false) {
    this.sortBy = sortByParams(this.sortBy);
    this.listingLayout = listingLayoutParams(this.listingLayout);

    const fullQuery = buildFullQuery({
      textSearch: this.main.dataset.filtersTextsearch,
      query: query,
      size: this.main.dataset.filtersPagesize,
      page: pagequery,
      sortBy: this.sortBy,
      listingLayout: this.listingLayout
    })

    const ajaxConf = {
      type: 'GET',
      url: fullQuery,
    };

    if (emitQuery) ajaxConf.success = () => {
      this.$emit(this.$customEvents.FILTERS_EVENTS.updated, {query: fullQuery,skipScroll});
    }

    if (showLoader) ajaxConf.beforeSend = () => this.$emit(this.$customEvents.LOADER_EVENTS.show);

    return $.ajax(ajaxConf);
  }

  buildQuery() {
    return buildQuery(this.main.dataset.filtersForm)
  }

  renderPage(res, append,skipProductRefresh, skipScroll = false) {
    this.forceClose();
    if (!append && !skipScroll) {
      $("html, body").animate({
        scrollTop: 0
      }, "slow");
    }
    let response = new DOMParser().parseFromString(res, 'text/html');
    let url = response.URL;
    this.main = document.querySelector(this.SELECTORS.main);
    let container = document.querySelector(this.main.dataset.filtersResult);
    let messageContainer = document.querySelector('.products-fetched');
    let filtersSelectedContainer = document.querySelector(this.main.dataset.filtersSelected);
    let responseResult = response.querySelector(this.main.dataset.filtersResult);
    let responseFiltersSelected = response.querySelector(this.main.dataset.filtersSelected);
    let responseMessage = response.querySelector('.products-fetched');
    let infiniteScrollButton = document.querySelector('[data-infinite-scroll]');
    this.focusTimeout = null;
    const pageSupportsPagination = $(this.SELECTORS.pagersContainer).length > 0;
    let newURL = url.replace("isRefineSearch=true", "isRefineSearch=false");
    if ($('body').hasClass('t-salesV2-category')) {
      newURL = url;
    }
    replacePageInHistory(newURL.replace(/\s.*/, ""),{},"", false);
    let sortBy = response.querySelector('.sort-by-dropdown');
    this.sortMethod = sortBy.dataset.sortMethod;
    this.sortType = sortBy.dataset.sortType;

    if (infiniteScrollButton) {
      let parsedQuery = queryString.parse(infiniteScrollButton.dataset.infiniteScrollQuery);
      parsedQuery.page = parseFloat(parsedQuery.page) + 1;
      document.querySelector('[data-infinite-scroll]').setAttribute('data-infinite-scroll-query', `?${queryString.stringify(parsedQuery)}`); // next page
      // update number of filtered products
      if (response.querySelector('[data-infinite-scroll]')) {
        document.querySelector('[data-infinite-scroll]').innerHTML = response.querySelector('[data-infinite-scroll]').innerHTML;
      }
    } else if(pageSupportsPagination){
      this.updatePager(response);
    }

    if (append) {
      clearTimeout(this.focusTimeout);
      if (responseResult.classList.contains('is-focus')) {

        while (responseResult.childNodes.length > 0) {
          container.appendChild(responseResult.childNodes[0]);
        }

      } else {

        let cards = responseResult.querySelectorAll('.products-row').length != 0
          ? responseResult.querySelectorAll('.products-row')
          : responseResult.querySelectorAll('.product-card');

        cards.forEach(card => container.append(card));
      }

      this.focusTimeout = setTimeout(() => {
        document.querySelector('.product-card').focus();
      }, 250);
    } else {

      if(!skipProductRefresh) {
        if (responseResult.innerHTML !== '') {
          container.innerHTML = responseResult.innerHTML;
        }
        if(responseMessage && responseMessage.innerHTML) {
          messageContainer.innerHTML = responseMessage.innerHTML;
        }
      }

      // se ci sono filtri e il container è visibile li aggiungo
      if (responseFiltersSelected && responseFiltersSelected.parentElement.classList.contains(this.CLASSES.visible)) {
        filtersSelectedContainer.parentElement.classList.add(this.CLASSES.visible);
        this.main.classList.add(this.CLASSES.isFiltered);
        filtersSelectedContainer.innerHTML = responseFiltersSelected.innerHTML;

        let count = responseFiltersSelected.querySelector(this.main.dataset.filtersCount).innerText;
        if (parseFloat(count)) {
          document.querySelectorAll(this.main.dataset.filtersCount).forEach(n => n.innerText = count);
          if (this.$matchMedia('lg', null)) {
            document.querySelectorAll(this.main.dataset.filtersCount).forEach(n => n.classList.add('is-visible'));
          } else {
            if (count >= 6) {
              document.querySelectorAll(this.main.dataset.filtersCount).forEach(n => n.classList.add('is-visible'));
            } else {
              document.querySelectorAll(this.main.dataset.filtersCount).forEach(n => n.classList.remove('is-visible'));
            }
          }
        } else {
          document.querySelectorAll(this.main.dataset.filtersCount).innerText = '';
          document.querySelectorAll(this.main.dataset.filtersCount).classList.remove('is-visible');
        }
      } else {
        const filtersCount = document.querySelector(this.main.dataset.filtersCount);
        filtersSelectedContainer.parentElement.classList.remove(this.CLASSES.visible);
        this.main.classList.remove(this.CLASSES.isFiltered);
        document.querySelectorAll(this.main.dataset.filtersCount).forEach(n => n.innerText = '');
        document.querySelectorAll(this.main.dataset.filtersCount).forEach(n => n.classList.remove('is-visible'));
      }
      this.$emit(this.$customEvents.FILTERS_EVENTS.updated, {
        updatedButton: infiniteScrollButton ? infiniteScrollButton.parentElement.innerHTML : false,
        hideButton: !response.querySelector('[data-infinite-scroll]'),
        response: response,
        res: res
      });
    }

    this.$emit(this.$customEvents.LOADER_EVENTS.hide);
  }

  updatePager(responseResult) {
    const $html = $(responseResult);
    const pagersContainer = this.SELECTORS.pagersContainer;
    const newPagination = $html.find(pagersContainer);
    const $oldPagination = $(pagersContainer);
    $oldPagination.empty().append(newPagination.children())
  }

  pageScrolled() {
    var scrolled = window.pageYOffset || document.documentElement.scrollTop;

    if ((scrolled > this.lastScrollTop) || scrolled == 0) {
      this.main.classList.remove(this.CLASSES.translate);
    } else {
      this.main.classList.add(this.CLASSES.translate);
    }

    this.lastScrollTop = scrolled <= 0 ? 0 : scrolled;
  }

  setPagination() {
    let dataInfiniteScroll = document.querySelector('[data-infinite-scroll]');

    if (dataInfiniteScroll) {
      dataInfiniteScroll.classList.remove('d-none');
      dataInfiniteScroll.style.display = '';
    }
  }

  bindFilters() {
    $(this.trigger).each((index, element) => {
      this.$on('click.filters', ({event}) => {
          event.preventDefault();
          this.toggleFiltersLayer(element);
          // manage search page case
          if (document.body.classList.contains('t-search')) {
            if (document.body.classList.contains(this.CLASSES.layerVisible)) {
              this.backdropSearch.addClass(this.CLASSES.backdropClass);
            } else {
              this.backdropSearch.removeClass(this.CLASSES.backdropClass);
            }
          } else {
            this.$emit(this.$customEvents.BACKDROP_EVENTS[
              `${document.body.classList.contains(this.CLASSES.layerVisible) ? 'show' : 'hide'}`
              ], {classes: 'dark'});
          }
        }, element);
    })
  }

  bindEvents() {
    this.$on('click.closeDropownSortBy', () => {
      this.forceClose();
    }, this.SELECTORS.closeDropdown);

    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.show, () => {
      this.forceClose();
    });

    this.$on(this.$customEvents.INFINITE_SCROLL_EVENTS.next, ({payload}) => {
      this.getPage(this.buildQuery(), true, true, payload.page).then(res => this.renderPage(res, true));
    });

    this.$on(this.$customEvents.PAGE_LAYOUT_EVENTS.changed, ({payload}) => {
      this.listingLayout = payload.layout;
      this.getPage(this.buildQuery()).then(res => this.renderPage(res)).then(function () {
        document.querySelector(".js-infinite-scroll").classList.remove("d-none");
      });
    });

    this.$on(this.$customEvents.SORT_BY_EVENTS.changed, ({payload}) => {
      this.sortBy = payload.value;
      this.sortName = payload.name;
      this.getPage(this.buildQuery()).then(res => {
        this.renderPage(res);
        this.TrackingComponent.actions.sortTracking(this.sortName, this.sortMethod, this.sortType);
        FiltersComponent.topFunction()
      });
    });

    this.$on(this.$customEvents.BACKDROP_EVENTS.hidden, this.forceClose(), this.main.dataset.filtersTrigger);

    this.$on('click.filtersReset', ({event,payload}) => {
      event.preventDefault();
      $('.js-resetfiltersform').trigger("submit");

    }, 'body', this.main.dataset.filtersReset);

    this.$on('change.filters', ({event,payload}) => {
      this.TrackingComponent.actions.filterTracking(event.target);

      let query = this.buildQuery();
      const {page,$focusElement,skipProductRefresh,skipScroll} = payload || {}

      this.getPage(`${query}`, false, true,page,skipScroll).then(res => {
        const response = new DOMParser().parseFromString(res, 'text/html');
        const originalCheckboxes = document.querySelectorAll(this.main.dataset.filtersCheckbox);

        for (let checkbox of originalCheckboxes) {
          const testEl = response.querySelector(`#${checkbox.id}`);

          if (!testEl) {
            checkbox.parentElement.parentElement.classList.add('disabled');
            checkbox.checked = false;
            checkbox.disabled = true;
          } else {
            checkbox.parentElement.parentElement.classList.remove('disabled');
            checkbox.disabled = false;
          }
        }

        this.setPagination();

        if(!this.$matchMedia('sm', null)) {
          let internalSkipScroll = skipScroll || (typeof $focusElement !== 'undefined' && $focusElement.length > 0) ;
          this.renderPage(res,false,skipProductRefresh, internalSkipScroll);
        }

        if(typeof $focusElement === 'undefined' || !$focusElement.length > 0){
          FiltersComponent.topFunction();
        }else{
          this.timedOutScrollToElement($focusElement);
        }
      });
    }, 'body', this.main.dataset.filtersCheckbox);

    this.$on('click.filtersRemove', ({event}) => {
      const checkboxValue = event.currentTarget.dataset.filtersValue;
      const checkbox = document.querySelector(`input[value="${checkboxValue}"]`);

      if (checkbox) {
        checkbox.checked = false
      }

      this.getPage(this.buildQuery(), false, true).then(res => {
        const response = new DOMParser().parseFromString(res, 'text/html');
        const originalCheckboxes = document.querySelectorAll(this.main.dataset.filtersCheckbox);

        originalCheckboxes.forEach(checkedCheckbox => {
          const toCheck = response.querySelector(`#${checkedCheckbox.id}`);

          if (!toCheck) {
            checkedCheckbox.parentElement.parentElement.classList.add('disabled');
            checkedCheckbox.checked = false;
            checkedCheckbox.disabled = true;
          } else {
            checkedCheckbox.parentElement.parentElement.classList.remove('disabled');
            checkedCheckbox.disabled = false;
          }
        })

        this.setPagination();
        this.renderPage(res)
      })

    }, 'body', this.main.dataset.filtersRemove);

    if (!document.body.classList.contains('t-search') && this.$matchMedia('sm', null)) {
      this.pageScrolled();
      this.$on('scroll', () => {
        if (!document.body.classList.contains('layer-visible')) this.pageScrolled();
      });
    }

    $(document).ready(() =>{
      const checkboxes = [...document.querySelectorAll(this.main.dataset.filtersCheckbox)];
      const originalCheckboxes = checkboxes.filter((checkbox) => checkbox.checked === true);

      const $focusElement = $(getFocusElement());
      if(typeof $focusElement != 'undefined') {
        const handleFocus = hasFocusElement() && $focusElement.length > 0;

        let paginationPayload = [
          {
            page: getQueryParameterByName("page"),
            skipProductRefresh: true,
            $focusElement,
            skipScroll:true
          }
        ];

        if(originalCheckboxes.length > 0) {
          $(originalCheckboxes[0]).trigger('change.filters', paginationPayload);
        } else if (handleFocus) {
          this.timedOutScrollToElement($focusElement);
        }
      }
    });
  }

  // When the user clicks on filters, scroll to the top of the document
  static topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  timedOutScrollToElement($element) {
    setTimeout(()=> {
      this.scrollToElement($element);
    },500)
  }

  scrollToElement($element) {
    $element.get(0).scrollIntoView({block: "center", inline: "nearest", behavior: "smooth"});
  }

  bindSubmit() {
    this.$on('submit.filters', ({event}) => {
        event.preventDefault();
        let query = this.buildQuery();
        this.getPage(query).then(res => this.renderPage(res));
      },
      this.main.dataset.filtersLayer
    );
  }

  render() {
    if (document.querySelector(this.SELECTORS.main)) {
      this.bindEvents();
      this.bindFilters();
      this.bindSubmit();

      let filtersSelectedContainer = document.querySelector(this.main.dataset.filtersSelected);

      if (filtersSelectedContainer.parentElement.classList.contains(this.CLASSES.visible)) {
        this.main.classList.add(this.CLASSES.isFiltered);
      }
    }
  }
}